import type { SvgType } from './types'

export default function FamilyUpdate({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill={fill}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5284 9.38827C20.3923 9.29474 13.4748 3.40156 11.8757 2.17238C11.6664 2.01151 11.6514 1.9997 11.5482 2.00001C11.4358 2.00043 11.4197 2.02077 11.1937 2.19692C9.54806 3.47944 2.73075 9.37043 2.65044 9.45074C2.35884 9.74228 2.54389 9.93055 2.73264 10.0629C3.27852 10.4457 4.08962 10.9745 5.21644 11.717C5.2612 11.7466 5.30607 11.7762 5.35095 11.8057C5.40855 11.8436 5.52394 11.8475 5.52394 11.6554V8.09693C5.52394 7.75302 5.80531 7.47159 6.14927 7.47159H16.9498C17.2937 7.47159 17.5752 7.75302 17.5752 8.09693C17.5752 8.09693 17.5752 10.7063 17.5752 11.5761C17.5752 11.7854 17.6716 11.7833 17.7185 11.7514C18.4407 11.2588 20.5226 9.86875 20.5226 9.86875C20.6061 9.81358 20.778 9.55992 20.5284 9.38827Z"
        fill={fill}
      />
      <path
        d="M21.0921 10.9572C21.0921 10.6687 20.9086 10.7897 20.9086 10.7897L13.94 15.4684C13.94 15.4684 13.7975 15.5769 13.6027 15.5769C13.5334 15.5769 9.4259 15.5965 9.4265 15.5878C9.21729 15.5878 9.12187 15.5163 9.06981 15.4799C6.93911 13.99 3.43096 11.7454 2.17305 10.8634C2.0257 10.7601 2 10.9211 2 10.9211V20.6727C2 21.4026 2.5972 21.9999 3.32709 21.9999H19.7721C20.5021 21.9999 21.0993 21.4026 21.0993 20.6727C21.0993 20.6728 21.0921 13.6746 21.0921 10.9572Z"
        fill={fill}
      />
      <path
        d="M13.0611 9.84131C12.2137 9.84131 11.6758 10.7861 11.5488 10.7861C11.4375 10.7861 10.9217 9.84131 10.0362 9.84131C9.17492 9.84131 8.4717 10.5516 8.42567 11.4118C8.39967 11.8976 8.55634 12.2674 8.77719 12.6024C9.21803 13.2715 11.1461 14.8824 11.5516 14.8824C11.9657 14.8824 13.8766 13.2774 14.3204 12.6024C14.5416 12.266 14.6978 11.8977 14.6718 11.4118C14.6256 10.5516 13.9225 9.84131 13.0611 9.84131Z"
        fill={fill}
      />
    </svg>
  )
}
